import React, { useEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import { montarGraficoClusteredColumnLineMensal } from "../common/graficos/montarGraficoClusteredColumnLineMensal";
import ContentCardBody from "../common/template/contentCardBody";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { atualizarListaGraficoDemanda, getDemanda, getDemandaContagem, getListaGraficoDemanda } from "./monitoramentoConsumoActions";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Td from "../common/table/td";
import NumberFormat from "react-number-format";
import { ModalAlert } from "../common/dialog/modalAlert";

const cores = {
    cores: [am4core.color("#0084ff"), am4core.color("#f6f21a"), am4core.color("#f49e13"), am4core.color("#12ffb8"), am4core.color("#ff5e76"), am4core.color("#00d5ff")],
};

function GraficoTabelaDemandaMensal(props) {
    const {
        itemSelecionado, //vem por prop do componente pai
        contratoDemanda,
        listaAgendamentoDemanda,
        listaGraficoDemanda,
        listaGraficoDemandaIndicesSazonalidade,
        listaDemandaContagem,
        getDemanda,
        getDemandaContagem,
        getListaGraficoDemanda,
        atualizarListaGraficoDemanda,
    } = props;

    if (!itemSelecionado) return null;

    const [contagemDemanda, setContagemDemanda] = useState(null);
    const [graficoDemandaMensal, setGraficoDemandaMensal] = useState(null);

    useEffect(() => {
        async function buscarDados() {
            await Promise.all([
                getDemanda({ id_unidade_consumidora: itemSelecionado.id_unidade_consumidora }),
                getDemandaContagem({ id_cliente: itemSelecionado.id_cliente, id_unidade_consumidora: itemSelecionado.id_unidade_consumidora }),
                getListaGraficoDemanda({
                    id_cliente: itemSelecionado.id_cliente,
                    id_unidade_consumidora: itemSelecionado.id_unidade_consumidora,
                    contrato_demanda_sazonal: itemSelecionado.contrato_demanda_sazonal,
                }),
            ]);
        }
        buscarDados();
        return desmontarTodosGraficos;
    }, [itemSelecionado]);

    useEffect(() => {
        atualizarGraficoDemanda();
        setContagemDemanda(listaDemandaContagem.find((contagem) => contagem.id_unidade_consumidora == itemSelecionado.id_unidade_consumidora));
    }, [JSON.stringify(listaGraficoDemanda)]);

    function desmontarTodosGraficos() {
        if (graficoDemandaMensal) graficoDemandaMensal.dispose();
    }

    function atualizarGraficoDemanda() {
        if (!listaGraficoDemanda.length) return;
        const fontColor = "#FFF";
        const exibirLinhas = true;
        const coluna3D = false;

        const dados = listaGraficoDemanda.map((item) => ({
            ...item,
            anos: item.anos.map((ano) => ({
                ...ano,
                ano: ano.ano || "",
            })),
        }));

        const graficoDemandaMensalAtualizado = montarGraficoClusteredColumnLineMensal(
            cores,
            graficoDemandaMensal,
            "graficoDemandaMensal",
            dados,
            "Demanda Mensal (kW)",
            "",
            "kW",
            exibirLinhas,
            coluna3D,
            fontColor
        );
        setGraficoDemandaMensal(graficoDemandaMensalAtualizado);
    }

    function renderizarCelulasZeradas(listaGraficoDemanda, listaPeriodoTeste, ano) {
        let listaMeses = [];
        for (let i = listaGraficoDemanda.length; i < 12; i++) {
            listaMeses.push(i < 10 ? "0" + i : i);
        }

        return listaMeses.map((mes) => {
            const anoMesEstaEmTeste = !!listaPeriodoTeste.find((periodoTeste) => periodoTeste.mes === mes && periodoTeste.ano === ano);

            return (
                <Td
                    key={mes}
                    alignCenter
                    color="#fff"
                    title={mes == primeiroMesNaoSazonal && ano == primeiroAnoNaoSazonal && !ucFiltradaSazonal ? "Primeiro mês Não Sazonal" : ""}
                    style={{
                        border:
                            mes == primeiroMesNaoSazonal && ano == primeiroAnoNaoSazonal && !ucFiltradaSazonal
                                ? "3px solid #00ff51"
                                : anoMesEstaEmTeste
                                ? "3px solid #257bfb"
                                : null,
                    }}
                >
                    0,00
                </Td>
            );
        });
    }

    useEffect(atualizarGraficoDemanda, [listaGraficoDemanda]);

    let ucFiltradaSazonal = false;
    let demandaAnoInicial = "";
    let demandaMesInicial = "";
    let demandaAnoFinal = "";
    let demandaMesFinal = "";
    let demandaCompetenciaInicial = "";
    let demandaCompetenciaFinal = "";
    let primeiroMesNaoSazonal = "";
    let primeiroAnoNaoSazonal = "";

    //se é não sazonal, pega os últimos 12 meses,
    const mesAtualDate = new Date().getMonth(); //não soma 1 pq o mes atual não deve ser contabilizado
    const anoAtual = String(new Date().getFullYear());
    //AQUI É A LÓGICA PARA PINTAR AS CÉLULAS DE CINZA
    if (contratoDemanda) {
        const mesLimite = mesAtualDate < 10 ? "0" + mesAtualDate : String(mesAtualDate);
        const mesesDescontar = Number(mesLimite) - 11; //diminui 11 meses para pegar o mes inicial dos últimos 12 meses
        const anoInicialCalculado = mesesDescontar > 0 ? anoAtual : anoAtual - 1; //se descontando 11 meses der negativo, considera ano anterior
        const mesInicialCalculado = Number(mesLimite) + 1 > 12 ? "01" : Number(mesLimite) + 1; //mes atual 10, inicia em 10+1 do ano anterior
        const competenciaInicialCalculada = Number(String(anoInicialCalculado) + String(mesInicialCalculado)); //usada pra comparar com competencia base
        //se competencia base for maior considera ela como inicial, senão considera a calculada
        const competenciaBaseSazonalidade =
            contratoDemanda.competencia_base_sazonalidade > competenciaInicialCalculada ? contratoDemanda.competencia_base_sazonalidade : competenciaInicialCalculada;

        ucFiltradaSazonal = contratoDemanda.unidade_consumidora_sazonal;
        demandaAnoInicial = ucFiltradaSazonal ? String(contratoDemanda.competencia_inicio).substring(0, 4) : String(competenciaBaseSazonalidade).substring(0, 4);
        demandaMesInicial = ucFiltradaSazonal ? String(contratoDemanda.competencia_inicio).substring(4, 6) : String(competenciaBaseSazonalidade).substring(4, 6);
        demandaAnoFinal = ucFiltradaSazonal ? String(contratoDemanda.competencia_fim).substring(0, 4) : anoAtual;
        demandaMesFinal = ucFiltradaSazonal ? String(contratoDemanda.competencia_fim).substring(4, 6) : mesLimite;
        demandaCompetenciaInicial = ucFiltradaSazonal ? parseInt(contratoDemanda.competencia_inicio) : competenciaBaseSazonalidade; //usado apenas no calculo de sazonalidade de uc Nao Sazonal
        demandaCompetenciaFinal = ucFiltradaSazonal ? parseInt(contratoDemanda.competencia_fim) : parseInt(`${anoAtual}${mesLimite}`);
        primeiroMesNaoSazonal = ucFiltradaSazonal ? "" : String(contratoDemanda.competencia_base_sazonalidade).substring(4, 6);
        primeiroAnoNaoSazonal = ucFiltradaSazonal ? "" : String(contratoDemanda.competencia_base_sazonalidade).substring(0, 4);
    }

    let corCiclo = "#30303d";
    let anos = [];
    listaGraficoDemanda.forEach((item) => {
        item.anos.forEach((ano) => {
            if (!anos.includes(ano.ano)) {
                anos.push(ano.ano);
            }
        });
    });
    if (demandaAnoInicial && !anos.includes(demandaAnoInicial)) {
        anos.push(demandaAnoInicial);
    }

    if (demandaAnoFinal && !anos.includes(demandaAnoFinal)) {
        anos.push(demandaAnoFinal);
    }
    anos = [
        ...anos.filter((item) => item.includes("Proposta")).sort((a, b) => b.length - a.length),
        ...anos.filter((item) => item.includes("Contratada")).sort((a, b) => b.length - a.length),
        ...anos.filter((item) => item.includes("Vigentes")),
        ...anos.filter((item) => !isNaN(parseInt(item))).sort((a, b) => a - b),
    ];

    const valoresDemandaContratada = [];

    const linhasDemanda = {};

    anos.forEach((ano) => {
        linhasDemanda[ano] = []; //cria a linha vazia

        //adiciona o valor de cada mes a linha
        listaGraficoDemanda.forEach((item) => {
            const itemLocalizado = item.anos.find((obj) => obj.ano == ano);
            if (itemLocalizado) {
                linhasDemanda[ano].push(itemLocalizado.valor);
            }
        });
    });

    const exibirLinhaProximoCiclo =
        !!linhasDemanda["Demanda Contratada"] && JSON.stringify(linhasDemanda["Demanda Contratada"]) !== JSON.stringify(linhasDemanda["Valores Já Vigentes Ciclo Rural Futuro"]);

    return (
        <ModalAlert
            maxWidth="90vw"
            contentStyle={{ overflow: "auto" }}
            titulo="Análise da Demanda Contratada"
            handleClose={() => {
                props.setItemSelecionado(null);
                props.setExibirModalAnaliseDemandaContratada(false);
            }}
        >
            <div>
                <div id="graficoDemandaMensal" style={{ width: "100%", minWidth: window.innerWidth < 768 ? 2000 : 1000, height: 400, backgroundColor: "#30303d", color: "#FFF" }} />
                <ContentCardBody style={{ minWidth: window.innerWidth < 768 ? 2000 : 1000, backgroundColor: "#30303d", color: "#FFF" }}>
                    <Table responsive>
                        <THead>
                            <Tr>
                                <Th>Demanda kW</Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "01" ? "#66bb6a" : demandaMesFinal == "01" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Janeiro
                                    {ucFiltradaSazonal ? (demandaMesInicial == "01" ? " (I)" : demandaMesFinal == "01" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "02" ? "#66bb6a" : demandaMesFinal == "02" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Fevereiro
                                    {ucFiltradaSazonal ? (demandaMesInicial == "02" ? " (I)" : demandaMesFinal == "02" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "03" ? "#66bb6a" : demandaMesFinal == "03" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Março
                                    {ucFiltradaSazonal ? (demandaMesInicial == "03" ? " (I)" : demandaMesFinal == "03" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "04" ? "#66bb6a" : demandaMesFinal == "04" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Abril
                                    {ucFiltradaSazonal ? (demandaMesInicial == "04" ? " (I)" : demandaMesFinal == "04" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "05" ? "#66bb6a" : demandaMesFinal == "05" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Maio
                                    {ucFiltradaSazonal ? (demandaMesInicial == "05" ? " (I)" : demandaMesFinal == "05" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "06" ? "#66bb6a" : demandaMesFinal == "06" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Junho
                                    {ucFiltradaSazonal ? (demandaMesInicial == "06" ? " (I)" : demandaMesFinal == "06" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "07" ? "#66bb6a" : demandaMesFinal == "07" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Julho
                                    {ucFiltradaSazonal ? (demandaMesInicial == "07" ? " (I)" : demandaMesFinal == "07" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "08" ? "#66bb6a" : demandaMesFinal == "08" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Agosto
                                    {ucFiltradaSazonal ? (demandaMesInicial == "08" ? " (I)" : demandaMesFinal == "08" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "09" ? "#66bb6a" : demandaMesFinal == "09" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Setembro
                                    {ucFiltradaSazonal ? (demandaMesInicial == "09" ? " (I)" : demandaMesFinal == "09" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "10" ? "#66bb6a" : demandaMesFinal == "10" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Outubro
                                    {ucFiltradaSazonal ? (demandaMesInicial == "10" ? " (I)" : demandaMesFinal == "10" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "11" ? "#66bb6a" : demandaMesFinal == "11" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Novembro
                                    {ucFiltradaSazonal ? (demandaMesInicial == "11" ? " (I)" : demandaMesFinal == "11" ? " (F)" : "") : ""}
                                </Th>
                                <Th
                                    alignCenter
                                    style={{
                                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "12" ? "#66bb6a" : demandaMesFinal == "12" ? "#ef5350" : null) : null,
                                    }}
                                >
                                    Dezembro
                                    {ucFiltradaSazonal ? (demandaMesInicial == "12" ? " (I)" : demandaMesFinal == "12" ? " (F)" : "") : ""}
                                </Th>
                                <Th alignCenter>Sazonalidade</Th>
                                <Th alignCenter>Fator de Carga</Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {anos.map((ano, i) => {
                                //adiciona cada período de teste encontrado na lista, para ser exibido na tabela
                                const listaPeriodoTeste = [];
                                listaDemandaContagem.map((demandaContagem) => {
                                    (demandaContagem.periodo_teste || []).map((periodoTeste) => {
                                        if (itemSelecionado.id_unidade_consumidora == demandaContagem.id_unidade_consumidora) {
                                            listaPeriodoTeste.push(JSON.parse(periodoTeste));
                                        }
                                    });
                                });

                                return (
                                    <>
                                        {
                                            //se existir agendamento na UC selecionada, lista abaixo da 2ª linha da tabela, como linha amarela
                                            listaAgendamentoDemanda.length && i == 2
                                                ? listaAgendamentoDemanda.map((agendamento) => (
                                                      <Tr key={agendamento.competencia_formatada} style={{ backgroundColor: "#f1cf1a", color: "#111" }}>
                                                          <Td>{agendamento.competencia_formatada}</Td>
                                                          {Object.keys(agendamento)
                                                              .filter((item) => item.substring(0, 6) === "valor_")
                                                              .map((_, indiceAgendamento) => (
                                                                  <Td key={indiceAgendamento} alignCenter color="#111">
                                                                      {parseFloat(agendamento[`valor_${indiceAgendamento + 1}`] || 0)
                                                                          .toFixed(2)
                                                                          .replace(".", ",")}
                                                                  </Td>
                                                              ))}
                                                      </Tr>
                                                  ))
                                                : null
                                        }
                                        {((exibirLinhaProximoCiclo && ano.includes("Vigentes")) || !ano.includes("Vigentes")) && (
                                            <Tr key={ano}>
                                                <Td
                                                    // color={ano.includes("Demanda Contratada") || ano.includes("Vigentes") ? "#000" : "#fff"}
                                                    color={"#fff"}
                                                    backgroundColor={ano.includes("Demanda Contratada") || ano.includes("Vigentes") ? "#826944" : null}
                                                >
                                                    {ano}
                                                </Td>
                                                {listaGraficoDemanda.map((mes, i) => {
                                                    const anoMesEstaEmTeste = !!listaPeriodoTeste.find((periodoTeste) => periodoTeste.mes === mes.mes && periodoTeste.ano === ano);
                                                    const competenciaLinha = parseInt(`${ano}${mes.mes}`);
                                                    const propsInicioNaoSazonalidade = {
                                                        title:
                                                            mes.mes == primeiroMesNaoSazonal && ano == primeiroAnoNaoSazonal && !ucFiltradaSazonal
                                                                ? "Primeiro mês Não Sazonal"
                                                                : "",
                                                        style: {
                                                            border:
                                                                mes.mes == primeiroMesNaoSazonal && ano == primeiroAnoNaoSazonal && !ucFiltradaSazonal
                                                                    ? "3px solid #00ff51"
                                                                    : anoMesEstaEmTeste
                                                                    ? "3px solid #257bfb"
                                                                    : null,
                                                        },
                                                    };
                                                    if (ucFiltradaSazonal) {
                                                        corCiclo = mes.mes == demandaMesInicial ? (demandaAnoInicial == ano ? "#595967" : "#30303d") : corCiclo;
                                                    } else {
                                                        corCiclo =
                                                            competenciaLinha >= demandaCompetenciaInicial && competenciaLinha <= demandaCompetenciaFinal ? "#595967" : "#30303d";
                                                    }

                                                    if (mes.anos.find((anoMes) => anoMes.ano == ano)) {
                                                        return mes.anos
                                                            .filter((anoMes) => anoMes.ano == ano)
                                                            .map((anoMes) => {
                                                                if (anoMes.ano.includes("Demanda Proposta")) {
                                                                    return (
                                                                        <Td
                                                                            key={anoMes.ano}
                                                                            alignCenter
                                                                            backgroundColor={corCiclo}
                                                                            style={{
                                                                                border: anoMesEstaEmTeste ? "3px solid #257bfb" : null,
                                                                            }}
                                                                        >
                                                                            <NumberFormat
                                                                                className="form-control"
                                                                                style={{
                                                                                    textAlign: "center",
                                                                                    maxWidth: 80,
                                                                                    height: 20,
                                                                                    fontSize: 13,
                                                                                    backgroundColor: anoMes.ano.includes("Demanda Proposta Máxima") ? "#cfd8dc" : null,
                                                                                }}
                                                                                disabled={anoMes.ano.includes("Demanda Proposta Máxima")}
                                                                                placeholder={"0"}
                                                                                decimalSeparator={","}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={2}
                                                                                value={String(anoMes.valor || "").replace(".", ",")}
                                                                                onChange={(data) => {
                                                                                    const listaDemanda = listaGraficoDemanda.map((item) => {
                                                                                        return {
                                                                                            mes: item.mes,
                                                                                            anos: item.anos.map((itemAno) => {
                                                                                                if (mes.mes == item.mes && itemAno.ano == anoMes.ano) {
                                                                                                    return {
                                                                                                        ...itemAno,
                                                                                                        valor: data.target.value.replace(",", "."),
                                                                                                    };
                                                                                                } else if (mes.mes == item.mes && itemAno.ano == `${anoMes.ano} Máxima`) {
                                                                                                    return {
                                                                                                        ...itemAno,
                                                                                                        valor: (parseFloat(data.target.value.replace(",", ".")) * 1.05).toFixed(2),
                                                                                                    };
                                                                                                } else {
                                                                                                    return itemAno;
                                                                                                }
                                                                                            }),
                                                                                        };
                                                                                    });

                                                                                    atualizarListaGraficoDemanda(listaDemanda);
                                                                                }}
                                                                            />
                                                                        </Td>
                                                                    );
                                                                } else {
                                                                    let corDemanda = "";
                                                                    let bgTexto = null;
                                                                    let corFonte = "#fff";
                                                                    if (parseInt(anoMes.ano)) {
                                                                        let demandaAtual = contratoDemanda
                                                                            ? contratoDemanda.itens.filter(
                                                                                  (demandaItem) => demandaItem.competencia == `${anoMes.ano}${anoMes.mes}`
                                                                              )[0]
                                                                            : null;

                                                                        if (demandaAtual) {
                                                                            if (anoMes.valor > demandaAtual.quantidade * 1.05) {
                                                                                corDemanda = "#ef5350";
                                                                            } else if (anoMes.valor >= demandaAtual.quantidade) {
                                                                                corDemanda = "#66bb6a";
                                                                            } else {
                                                                                corDemanda = corCiclo;
                                                                            }
                                                                        } else {
                                                                            corDemanda = corCiclo;
                                                                        }
                                                                    } else if (anoMes.ano.includes("Demanda Contratada")) {
                                                                        corDemanda = "#826944"; //pinta a demada vigente de marrom
                                                                        // corFonte = "#000";
                                                                        if (!anoMes.ano.includes("Máxima")) {
                                                                            valoresDemandaContratada.push(parseFloat(anoMes.valor || 0)); //adiciona cada valor de "Demanda Contratada" no array
                                                                        }
                                                                    } else if (anoMes.ano.includes("Vigentes")) {
                                                                        //os do proximo ciclo diferente do atual pinta de marrom
                                                                        corDemanda = "#826944";
                                                                        if (anoMes.valor != valoresDemandaContratada[i]) {
                                                                            bgTexto = "#543617";
                                                                        }
                                                                        // corFonte = "#000";
                                                                    }
                                                                    return (
                                                                        <Td
                                                                            key={anoMes.ano + "-" + anoMes.mes}
                                                                            alignCenter
                                                                            color={corFonte}
                                                                            backgroundColor={corDemanda}
                                                                            {...propsInicioNaoSazonalidade}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    margin: 3,
                                                                                    padding: 3,
                                                                                    borderRadius: 4,
                                                                                    backgroundColor: bgTexto,
                                                                                }}
                                                                            >
                                                                                {parseFloat(anoMes.valor || 0)
                                                                                    .toFixed(2)
                                                                                    .replace(".", ",")}
                                                                            </div>
                                                                        </Td>
                                                                    );
                                                                }
                                                            });
                                                    } else {
                                                        return (
                                                            <Td key={ano + "-" + mes.mes} alignCenter backgroundColor={corCiclo} color="#fff" {...propsInicioNaoSazonalidade}>
                                                                0,00
                                                            </Td>
                                                        );
                                                    }
                                                })}
                                                {renderizarCelulasZeradas(listaGraficoDemanda, listaPeriodoTeste, ano)}
                                                <Td
                                                    alignCenter
                                                    width={120}
                                                    backgroundColor={demandaAnoFinal == ano ? "#005662" : "#40838f"}
                                                    fontWeight={
                                                        parseFloat((listaGraficoDemandaIndicesSazonalidade.find((saz) => saz.ano == ano) || {}).sazonalidade) <= 0.2
                                                            ? "bold"
                                                            : "normal"
                                                    }
                                                    color={
                                                        parseFloat((listaGraficoDemandaIndicesSazonalidade.find((saz) => saz.ano == ano) || {}).sazonalidade) <= 0.2
                                                            ? "#3f3"
                                                            : "#fff"
                                                    }
                                                >
                                                    {((listaGraficoDemandaIndicesSazonalidade.find((saz) => saz.ano == ano) || {}).sazonalidade || "-").replace(".", ",")}
                                                </Td>
                                                <Td backgroundColor="#317ffe" alignCenter width={120}>
                                                    {isNaN(parseFloat((listaGraficoDemandaIndicesSazonalidade.find((saz) => saz.ano == ano) || {}).fator_carga))
                                                        ? " - "
                                                        : parseFloat((listaGraficoDemandaIndicesSazonalidade.find((saz) => saz.ano == ano) || {}).fator_carga)
                                                              .toFixed(2)
                                                              .replace(".", ",")}
                                                </Td>
                                            </Tr>
                                        )}
                                    </>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
                {contagemDemanda ? (
                    <Row style={{ width: "100%", minWidth: window.innerWidth < 768 ? 2000 : 1000 }}>
                        <Grid cols="4 4 4 4">
                            <div style={{ margin: 5, minHeight: 104 }} className="info-box bg-yellow">
                                <span className="info-box-icon">
                                    <i className="fas fa-circle-notch"></i>
                                </span>
                                <div className="info-box-content">
                                    <span style={{ marginBlock: 5 }} className="info-box-text">
                                        {ucFiltradaSazonal ? "FATURAS DO CICLO SAZONAL" : " Nº MESES SEM SAZONALIDADE"}
                                    </span>
                                    <span style={{ marginBlock: 5 }} className="info-box-number">
                                        {ucFiltradaSazonal ? contagemDemanda.lidas || 0 : contagemDemanda.meses_nao_sazonal}
                                    </span>
                                    {ucFiltradaSazonal ? (
                                        <>
                                            <div style={{ marginBlock: 5, height: 8 }} className="progress">
                                                <div
                                                    className="progress-bar"
                                                    style={{
                                                        marginTop: 2,
                                                        marginInline: 2,
                                                        height: 4,
                                                        width: `${((contagemDemanda.lidas || 0) * 100) / contagemDemanda.competencias}%`,
                                                    }}
                                                ></div>
                                            </div>
                                            <span className="progress-description">{(contagemDemanda.lidas || 1) + " de 12"}</span>
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        </Grid>
                        <Grid cols="4 4 4 4">
                            <div style={{ margin: 5 }} className="info-box bg-green">
                                <span className="info-box-icon">
                                    <i className="fas fa-angle-up"></i>
                                </span>
                                <div className="info-box-content">
                                    <span style={{ marginBlock: 5 }} className="info-box-text">
                                        ATINGIU SEM ULTRAPASSAR
                                    </span>
                                    <span style={{ marginBlock: 5 }} className="info-box-number">
                                        {(contagemDemanda.atingidas || 0) - (contagemDemanda.ultrapassagens || 0)}
                                    </span>
                                    <div style={{ marginBlock: 5, height: 8 }} className="progress">
                                        <div
                                            className="progress-bar"
                                            style={{
                                                marginTop: 2,
                                                marginInline: 2,
                                                height: 4,
                                                width: `${(((contagemDemanda.atingidas || 0) - (contagemDemanda.ultrapassagens || 0)) * 100) / 12}%`,
                                            }}
                                        ></div>
                                    </div>
                                    <span className="progress-description">{(contagemDemanda.lidas || 1) + " de 12"}</span>
                                </div>
                            </div>
                        </Grid>
                        <Grid cols="4 4 4 4">
                            <div style={{ margin: 5 }} className="info-box bg-red">
                                <span className="info-box-icon">
                                    <i className="fas fa-angle-double-up"></i>
                                </span>
                                <div className="info-box-content">
                                    <span style={{ marginBlock: 5 }} className="info-box-text">
                                        ATINGIU COM ULTRAPASSAGEM
                                    </span>
                                    <span style={{ marginBlock: 5 }} className="info-box-number">
                                        {contagemDemanda.ultrapassagens || 0}
                                    </span>
                                    <div style={{ marginBlock: 5, height: 8 }} className="progress">
                                        <div
                                            className="progress-bar"
                                            style={{
                                                marginTop: 2,
                                                marginInline: 2,
                                                height: 4,
                                                width: `${((contagemDemanda.ultrapassagens || 0) * 100) / 12}%`,
                                            }}
                                        ></div>
                                    </div>
                                    <span className="progress-description">{(contagemDemanda.lidas || 1) + " de 12"}</span>
                                </div>
                            </div>
                        </Grid>
                    </Row>
                ) : null}
            </div>
        </ModalAlert>
    );
}

const mapStateToProps = (state) => {
    return {
        contratoDemanda: state.monitoramentoConsumo.contratoDemanda,
        listaAgendamentoDemanda: state.monitoramentoConsumo.listaAgendamentoDemanda,
        listaGraficoDemanda: state.monitoramentoConsumo.listaGraficoDemanda,
        listaGraficoDemandaIndicesSazonalidade: state.monitoramentoConsumo.listaGraficoDemandaIndicesSazonalidade,
        listaDemandaContagem: state.monitoramentoConsumo.listaDemandaContagem,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDemanda,
            getDemandaContagem,
            getListaGraficoDemanda,
            atualizarListaGraficoDemanda,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GraficoTabelaDemandaMensal);
